import React from 'react';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import { ModuleDialogs } from '../../constants/Dialogs';
import { asDialog, withValidation } from '../Common/Decorators';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '../../actions/DialogActionCreator';
import TextField from 'material-ui/TextField';
import ModuleActions from '../../actions/ModuleActionCreator';

const validCode = new RegExp('^\\w+$');

const validate = ({code}) => {
    const errors = {};
    if (!code) {
        errors.code = 'Required';
    } else if (!validCode.test(code)) {
        errors.code = 'Can only contain letters and numbers';
    }
    return errors;
};

const SetModuleCodeDialog = ({draft, errors = {}}) =>  (
    <Dialog
        open={true}
        title="Set module code"
        actions={[
            <FlatButton key="cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
            <FlatButton
                key="submit"
                label="Submit"
                disabled={!draft.id || Object.keys(errors).length > 0}
                onTouchTap={() => {
                    ModuleActions.setCode(draft.id, draft.code)
                        .then(DialogActions.close())
                }}
            />
        ]}
    >
        <div>In order to publish media, the module needs to have a unique code.</div>
        <div>
            <TextField
                name="code"
                floatingLabelText="Module Code"
                value={draft.code}
                onChange={({target}) => DialogActions.updateDraft(target.name, target.value)}
                errorText={errors.code}
                required
            />
        </div>
    </Dialog>
);

SetModuleCodeDialog.propTypes = {
    draft: PropTypes.shape({
        id: PropTypes.number.isRequired,
        code: PropTypes.string
    }),
    errors: PropTypes.object
};

export default asDialog(withValidation(SetModuleCodeDialog, validate), ModuleDialogs.SET_CODE);
